export default __webpack_public_path__ + "static/media/makkaj-website-logo.3f5b2e06.png";